import React, {useState} from 'react'
import { Card, Tooltip , CardBody,CardFooter,CardTitle,CardSubtitle,CardText , Row, Col,  Button, Input} from "reactstrap";
import { addStockById,deleteProdID } from 'network/ApiAxiosMerchShop';
import {ddns} from '../../../../package.json'
import { jsPDF } from "jspdf";
import QRCode from 'qrcode';


function ProdCard(props) {
    const [QT, setQT] = useState('');
    const [tooltipOpen, setTooltipOpen] = useState(false);
    const [stockResp, setStockResp] = useState('');
    

    const addToCart = (prod)=>{
        
        if(QT > prod.stock || QT==''){return}
        else{
            let cartItem = {_id : prod._id, qt: QT, prod: props.prod}
            if(!localStorage.getItem("cartShop")){
                localStorage.setItem("cartShop", JSON.stringify([cartItem]));
                setQT("")
                //document.getElementById("btn" + prod._id).style.display = "none"
                props.updateCartQT()
            }else{
                let cartArray = JSON.parse(localStorage.getItem("cartShop"))
                const checkExists = cartArray.findIndex(element => element._id == prod._id)
                if(checkExists == -1){
                    cartArray.push(cartItem)
                    setQT("")
                    //document.getElementById("btn" + prod._id).style.display = "none"
                    props.updateCartQT()
                }else{
                    if(parseInt(cartArray[checkExists].qt) + parseInt(QT) > prod.stock){
                    alert("Not enough tickets left. Too many in the cart already")
                    }else{
                    cartArray[checkExists].qt = parseInt(cartArray[checkExists].qt) + parseInt(QT)
                    setQT("")
                    //document.getElementById("btn" + prod._id).style.display = "none"
                    props.updateCartQT()
                    }
                }
                localStorage.setItem("cartShop", JSON.stringify(cartArray))
            }
        }
        
    }

    const addStock = async(id)=>{
        const resp = await addStockById(id,QT)
        if(resp.data.success){
            setTooltipOpen(!tooltipOpen)
            setStockResp('Saved!')
            setTimeout(() => {
                setQT(0)
                setTooltipOpen(false)
            }, 3000);
            props.update(!props.updateState)
        }else{
            setTooltipOpen(!tooltipOpen)
            setStockResp('ERROR!')
            setTimeout(() => {
                setTooltipOpen(false)
            }, 3000);
        }
    }

    const handleDelete = async(e)=>{
        const resp = await deleteProdID(e)
        if(resp.data.success){
            props.update(true)
        }
        props.update(!props.updateState)
    }

    const sizeHandler =(size)=>{
        switch (size) {
            case 'XXL':
                return '2XL'
                break;
            case 'XXXL':
                return '3XL'
                break;
            case 'XXXXL':
                return '4XL'
                break;
            default:
                return size
                break;
        }
    }

    const handleQrCodeNew =async()=>{
        var doc = new jsPDF();
        const testQT = QT ? QT : 1
        let lineCount = 1
        let collumnCount = 1
        const imageSize = 50
        const margin = 15
        //doc.addImage(qrcodeImage,'stringData','0','0','20%','20%')
        // a4 210 X 842
        // 15 50 15 50 15 50 15 width
        const qrcodeImage = await QRCode.toDataURL(props.prod._id,{type:'image/png'})
        for (let index = 0; index < testQT; index++) {
            //const element = array[index];
            doc.addImage({
                imageData:qrcodeImage,
                x: margin * lineCount + imageSize * (lineCount - 1),
                y:(margin * collumnCount )+ (imageSize * (collumnCount - 1)) + (30 * (collumnCount - 1)) ,
                width:imageSize,
                height:imageSize
            })
            doc.setFontSize(14);
            doc.text(
                props.prod.house,
                (margin * lineCount + imageSize * (lineCount - 1)) + 25,
                (margin * collumnCount )+ (imageSize * (collumnCount - 1)) + imageSize + 5 + (30 * (collumnCount - 1)),
                null,
                null,
                'center'
            )
            doc.text(
                props.prod.desc,
                (margin * lineCount + imageSize * (lineCount - 1)) + 25,
                (margin * collumnCount )+ (imageSize * (collumnCount - 1)) + imageSize + 10 + (30 * (collumnCount - 1)),
                null,
                null,
                'center'
            )
            doc.text(
                sizeHandler(props.prod.size),
                (margin * lineCount + imageSize * (lineCount - 1)) + 25,
                (margin * collumnCount )+ (imageSize * (collumnCount - 1)) + imageSize + 15 + (30 * (collumnCount - 1)),
                null,
                null,
                'center'
            )
            doc.text(
                props.prod.color.toString(),
                (margin * lineCount + imageSize * (lineCount - 1)) + 25,
                (margin * collumnCount )+ (imageSize * (collumnCount - 1)) + imageSize + 20 + (30 * (collumnCount - 1)),
                null,
                null,
                'center'
            )
            doc.text(
                String(props.prod.price) + '€',
                (margin * lineCount + imageSize * (lineCount - 1)) + 25,
                (margin * collumnCount )+ (imageSize * (collumnCount - 1)) + imageSize + 25 + (30 * (collumnCount - 1)),
                null,
                null,
                'center'
            )
            
            if(lineCount == 3){
                if(collumnCount == 3){
                    lineCount = 1
                    collumnCount = 1
                    doc.addPage('a4')
                    let tempCount = 1
                    while (tempCount != 10) {
                        doc.addImage('/static/media/argon-react.994425e5.png',
                            'PNG',
                            margin * lineCount + imageSize * (lineCount - 1),
                            (margin * collumnCount )+ (imageSize * (collumnCount - 1)) + (30 * (collumnCount - 1)) ,
                            imageSize,
                            imageSize
                        )
                        tempCount++
                        if(lineCount == 3){
                            lineCount = 1
                            collumnCount++
                        }else{lineCount++}
                    }
                    lineCount = 1
                    collumnCount = 1
                    doc.addPage('a4')
                }else{
                    collumnCount++
                    lineCount=1
                }
            }else{
                lineCount++
            }
        }
        //doc.addPage("a4");

        lineCount = 1
        collumnCount = 1
        doc.addPage('a4')
        let tempCount = 1
        while (tempCount != 10) {
            doc.addImage('/static/media/argon-react.994425e5.png',
                'PNG',
                margin * lineCount + imageSize * (lineCount - 1),
                (margin * collumnCount )+ (imageSize * (collumnCount - 1)) + (30 * (collumnCount - 1)) ,
                imageSize,
                imageSize
            )
            tempCount++
            if(lineCount == 3){
                lineCount = 1
                collumnCount++
            }else{lineCount++}
        }
        doc.save("qrcodes.pdf")
    }

  return (
    <Card style={{ width: '18rem'}}>
        
        <img
            alt="Sample"
            //src="https://picsum.photos/300/200"
            src={ddns + '/userfiles/merchshop/prodimages/' + props.prod.picture}
        />
        <CardBody>
            <CardTitle tag="h5">
                {props.name}
            </CardTitle>
            <CardSubtitle> {'Price: ' + props.prod.price + '€'} </CardSubtitle>
            <CardText>{'Size: ' + sizeHandler(props.prod.size)}<br/>
            {'Stock: ' + props.prod.stock}
            </CardText>

            <Input id="qt" type="number" max={props.prod.stock} value={QT} placeholder="Qt." onChange={e=>{
                document.getElementById("btn" + props.prod._id).style.display = "block"
                setQT(e.target.value)}} />
            
        </CardBody>
        <CardFooter className='p-2'>
            <Tooltip
                autohide= {true}
                flip= {true}
                isOpen={tooltipOpen}
                target={"btn" + props.prod._id + 'stock'}
            >
                {stockResp}
            </Tooltip>
            <Row className='mb-6'>
                <Col lg='6' xs='6'  className='m-0 pl-4 pr-2'>
                    <button id={"btn" + props.prod._id + 'stock'} style={{ width: '100%' , height:'60%'}} className="mb-4 btn-danger bg-cyan border-neutral" onClick={()=>{
                        handleQrCodeNew()}} >Print QR</button>
                
                    <Button id={"btn" + props.prod._id + 'delete'} style={{ width: '100%' , height:'60%'}} className='btn-danger text-center pl-2' onClick={()=>handleDelete(props.prod._id)}>Delete</Button>
                </Col>
                <Col lg='6' xs='6' className='m-0 pl-2 pr-4'>
                    <button id={"btn" + props.prod._id + 'stock'} style={{ width: '100%' , height:'60%'}} className="mb-4 btn-danger bg-cyan border-neutral" onClick={(e)=>{
                        addStock(props.prod._id)}} >Add Stock</button>
                    
                    <button id={"btn" + props.prod._id} style={{ width: '100%' , height:'60%'}} className="btn-danger bg-blue border-neutral" onClick={(e)=>{
                        addToCart(props.prod)}} >Add To Cart</button>
                </Col>
            </Row>
        </CardFooter>
    </Card>
  )
}

export default ProdCard